import { useState } from 'react';
import { Flex, Text } from '@backstage/ui';

import { CheckDetailDialog } from '../CheckDetailDialog/CheckDetailDialog';
import type { CheckRow } from '../../hooks/useEntityScorecard';
import { ChecksTable } from '../ChecksTable/ChecksTable';
import { useEntityScorecard } from '../../hooks/useEntityScorecard';
import { ScorecardsFilterProvider } from './ScorecardsFilterContext';
import { SummaryCards } from './SummaryCards';

export const EntityScorecardsTab = () => {
  const { rows, isLoading, error } = useEntityScorecard();
  const [selectedRow, setSelectedRow] = useState<CheckRow | null>(null);

  if (error) {
    return (
      <Text as="p" color="danger">
        Failed to load scorecards: {error.message}
      </Text>
    );
  }

  return (
    <ScorecardsFilterProvider>
      <Flex direction="column" p="4">
        <SummaryCards rows={rows} isLoading={isLoading} />
        <ChecksTable
          rows={rows}
          isLoading={isLoading}
          onRowClick={setSelectedRow}
        />
        <CheckDetailDialog
          row={selectedRow}
          onClose={() => setSelectedRow(null)}
        />
      </Flex>
    </ScorecardsFilterProvider>
  );
};
